import { useTranslation } from 'react-i18next';

import {
    IconChevronRight,
    Subtitle1,
    TextButton,
} from '@myphx-engineering/phx-design-system';
import { AddHomeLillyIllustration, IllustrationCard } from '@phx/myphx-lib';
import { getCurrentOs, usePwaContext } from '@phx/pwa';

const userOs = getCurrentOs();

export const AddToHomeCard = () => {
    const { t } = useTranslation();
    const { installApp } = usePwaContext();

    return (
        <IllustrationCard
            Illustration={AddHomeLillyIllustration}
            variant="filled"
            color="info"
            header={<Subtitle1>{t('home.addToHomeCard.heading')}</Subtitle1>}
            onClick={installApp}
            // oxlint-disable-next-line jsx-a11y/role-has-required-aria-props -- tracked in docs/oxlint-violations.md
            role="tab"
        >
            <TextButton RightIcon={IconChevronRight} justify="flex-start">
                {userOs === 'ios'
                    ? t('home.addToHomeCard.button.ios')
                    : t('home.addToHomeCard.button.other')}
            </TextButton>
        </IllustrationCard>
    );
};
